import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { getInputColors } from './helper/colors';

const StyledMessage = styled.p`
  margin-top: 2px;
  margin-bottom: 0px;
  ${props => getInputColors(props)}
  line-height: 16px;
  min-height: 16px;
  display: block;
`;

function Message({
  errorMessage,
  successMessage,
  infoMessage,
  showErrorMessage,
  showSuccessMessage,
  showInfoMessage,
}) {
  return (
    <StyledMessage
      showErrorMessage={showErrorMessage}
      showSuccessMessage={showSuccessMessage}
    >
      {showErrorMessage && errorMessage}
      {showSuccessMessage && successMessage}
      {showInfoMessage && infoMessage}
    </StyledMessage>
  );
}

Message.propTypes = {
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  infoMessage: PropTypes.string,
  showErrorMessage: PropTypes.bool,
  showSuccessMessage: PropTypes.bool,
  showInfoMessage: PropTypes.bool,
};

export default Message;
